module.exports = __webpack_public_path__ + "static/media/Junk-Car-Removal-Beenleigh.21069767.jpg";